import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitCreateKnowledgeBaseTextDocument,
  submitDeleteKnowledgeBaseDocument,
  submitUpdateKnowledgeBaseDocument,
  submitUploadKnowledgeBaseFileDocument
} from '~/api/data/knowledge/mutations';
import {
  loadKnowledgeBase,
  loadKnowledgeBaseDocument,
  loadKnowledgeBases
} from '~/api/data/knowledge/queries';
import {
  KnowledgeBaseDocumentCreatePage,
  KnowledgeBaseDocumentEditPage,
  KnowledgeBaseDocumentPage,
  KnowledgeBasePage
} from '~/pages/knowledge/knowledge';
import { KnowledgeBasesListPage } from '~/pages/knowledge/knowledge-bases';

export const knowledgeRoutes: RouteObject[] = [
  {
    path: 'knowledge',
    loader: merge({
      knowledgeBases: loadKnowledgeBases
    }),
    element: <KnowledgeBasesListPage />
  },
  {
    id: 'knowledge/:knowledgeBaseId',
    path: 'knowledge/:knowledgeBaseId',
    loader: merge({
      knowledgeBase: loadKnowledgeBase
    }),
    action: byMethod({
      POST: submitUploadKnowledgeBaseFileDocument
    }),
    element: <KnowledgeBasePage />,
    children: [
      {
        path: 'new',
        action: byMethod({
          POST: submitCreateKnowledgeBaseTextDocument
        }),
        element: <KnowledgeBaseDocumentCreatePage />
      },
      {
        path: ':documentId',
        loader: merge({
          knowledgeBaseDocument: loadKnowledgeBaseDocument
        }),
        action: byMethod({
          DELETE: submitDeleteKnowledgeBaseDocument
        }),
        element: <KnowledgeBaseDocumentPage />
      },
      {
        path: ':documentId/edit',
        loader: merge({
          knowledgeBaseDocument: loadKnowledgeBaseDocument
        }),
        action: byMethod({
          PUT: submitUpdateKnowledgeBaseDocument
        }),
        element: <KnowledgeBaseDocumentEditPage />
      }
    ]
  }
];
